import { createServerFn } from "@tanstack/react-start";

import { getBlogPostBySlugServer, listBlogPostsServer } from "./ops";

export const listBlogPostsFn = createServerFn({ method: "GET" }).handler(async () => {
    return listBlogPostsServer();
});

export const getBlogPostBySlugFn = createServerFn({ method: "GET" })
    .inputValidator((data: { slug: string }) => data)
    .handler(async ({ data }) => {
        return getBlogPostBySlugServer(data.slug);
    });
